import React from 'react'
import { Item } from './Item'

export function ListItem({ list, codigo_produto, sequencia }) {
    return list.map((item, index) => <Item key={item.id} item={item} index={index} codigo_produto={codigo_produto} sequencia={sequencia} />)
}
